import { 
  IconButton, 
  Badge, 
  Menu, 
  MenuItem, 
  Box, 
  Typography,
  Divider,
  Avatar
} from '@mui/material';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import api from '../../services/api';

const NotificationBell = () => {
  const [notifications, setNotifications] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const unreadCount = notifications.filter(n => !n.read).length;

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await api.get('/notifications');
        setNotifications(response.data.data);
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };
    fetchNotifications();
  }, []);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMarkAsRead = async (id) => {
    try {
      await api.patch(`/notifications/${id}/read`);
      setNotifications(prev => 
        prev.map(n => n._id === id ? { ...n, read: true } : n)
      );
    } catch (error) {
      console.error('Error marking as read:', error);
    }
  };

  return (
    <>
      <IconButton
        size="large"
        color="inherit"
        onClick={handleOpen}
        sx={{ mr: 1 }}
      >
        <Badge badgeContent={unreadCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: 350,
            maxHeight: 400,
            py: 0
          }
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            Notifications
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {unreadCount} unread messages
          </Typography>
        </Box>
        <Divider />

        {notifications.length > 0 ? (
          notifications.map(notification => (
            <MenuItem 
              key={notification._id}
              onClick={() => handleMarkAsRead(notification._id)}
              sx={{ 
                py: 1.5,
                borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                '&:last-child': { borderBottom: 'none' }
              }}
            >
              <Box sx={{ width: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Avatar sx={{ 
                    width: 32, 
                    height: 32, 
                    mr: 1.5,
                    bgcolor: notification.read ? 'grey.300' : 'primary.main'
                  }}>
                    {!notification.read && (
                      <NotificationsIcon fontSize="small" sx={{ color: 'white' }} />
                    )}
                  </Avatar>
                  <Typography variant="body2">
                    {notification.message}
                  </Typography>
                </Box>
                <Typography 
                  variant="caption" 
                  color="text.secondary"
                  sx={{ display: 'block', ml: 4.5 }}
                >
                  {new Date(notification.createdAt).toLocaleDateString('en-US', {
                    weekday: 'short',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </Typography>
              </Box>
            </MenuItem>
          ))
        ) : (
          <Box sx={{ p: 2 }}>
            <Typography variant="body2" color="text.secondary">
              No new notifications
            </Typography>
          </Box>
        )}
      </Menu>
    </>
  );
};

export default NotificationBell;